import React from 'react';
import Viewports from '../../assets/components/fsUtils/Viewports';
import FsPlayer from '../shared/components/FsPlayer';
import VideoPlaylist from '../videoPlayer/components/VideoPlaylist';
import VideoPlayerShare from '../videoPlayer/components/VideoShare';
import { css } from 'aphrodite/no-important';
import { loadVideoPlayer } from '../shared/services/VideoPlayerService';
import { playerStyles } from '../videoPlayer/components/styles/VideoPlayerStyles';
import scrollEvent from '../../assets/components/fsUtils/scrollEvent';

class VideoPlayer extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            playlist: this.props.playlist,
            defaultVideo: this.props.playlist.length > 0 ? this.props.playlist[0] : null,
            width: window.innerWidth,
            currentIndex: 0,
            activeIndex: 1,
            viewAllLink: this.props.viewAllLink,
            hideUnavailableMsg: 'false' === this.props.showUnavailableMsg,
            autoplay: this.props.autoplay,
            unAvailableMsg: this.props.unAvailableMsg || 'Highlights Unavailable',
            playlistTitle: this.props.playlistTitle,
            playerInstance: null,
            isAvailable: true
        }

        this.viewport = new Viewports();
        this.playerMetaHeight = 0;
        this.playlistCont = null;
        this.playlistItems = null;

        //sets up callback which returns post meta of the clicked video 
        this.updateCurrentPost = this.updateCurrentPost.bind(this);        
        this.updateDetails = this.updateDetails.bind(this);
        this.setActiveState = this.setActiveState.bind(this);

    }

    /**
     * updates details
     * @param {*} e - event
     */
    updateDetails(e) {
        let el = this.playerMeta;
        if(this.viewport.isMobile || this.viewport.winW <= 767) {
            this.setState(() => ({
                displayDetails: e.target.scrollTop <= 0
            }))
        }
    }

    /**
     * set active state
     * @param {int} index returned by VideoPlaylistItem
     */
    setActiveState( index ) {
        this.setState({ activeIndex: index });
        this.scrollToCurrentVideo( index - 1 );
    }

    /**
     * updates current post
     * @param {object} post  
     */
    updateCurrentPost(data) {
        this.setState({defaultVideo: data});
        let isAvaiable = this.state.playlist.length > this.state.activeIndex
        this.updateReleaseUrl( data, isAvaiable);
    }

    /**
     * updates the fdmPlayer release url
     */
    updateReleaseUrl( data, available = false){
        //use playNextVideo method to play the video the user click on
        this.state.playerInstance.playVideo(data, available);
    }

    /**
     * encode the tags passed to the player on default-video-tags and playlist-tags attributes
     * @param {string} tags 
     */
    encodeParselyTags(tags) {
        if( tags ) {
            tags = tags.split(',');
            let fullTagUri = '';
            for (let i = 0; i < tags.length; i++) {
                fullTagUri += ('&' + tags[i]);
            }
            return encodeURIComponent(fullTagUri);
        }
    }

    componentDidMount() {

        let playerCont = document.querySelector('.vid-player-cont');
        if(playerCont) {
            let player = playerCont.querySelector('.fs-video-player');
            player.setAttribute('enable-pinning', 'true');
            setTimeout(()=> {
                loadVideoPlayer(player, playerCont.clientWidth, playerCont.clientHeight, null);
            }, 0);
        }
    

        if( ! this.playlistCont ) {
            this.playlistCont = document.querySelector('.playlist-container');
            this.playlistItems = this.playlistCont && this.playlistCont.querySelectorAll( 'div > a' );
        }
        
        //listen to the video player end
        if( window.FsVideoEventHandler ) { 
            window.FsVideoEventHandler.onPlayerLoaded( (data) => this.onPlayerLoaded(data));
            window.FsVideoEventHandler.onVideoEnd((data) => this.updatePostOnVideoEnd(data));
            window.FsVideoEventHandler.onVideoStart((data) => this.onVideoStart(data));
        }
        
    }

    onPlayerLoaded(data) {
        //save the player instance that was used when we loaded the component
        if(!this.state.playerInstance) {
            this.setState({ 
                playerInstance: data.fngPlayer || data.player
            });
            //disable default playlist
            this.state.playerInstance.disablePlaylist = true;
        }
    }

    /**
     * Sets player video url
     * @param {object} data 
     */
    onVideoStart(data) {
        data.player.url = this.state.defaultVideo.videoUrl;
    }

    /**
     * scroll to current video playing
     */
    scrollToCurrentVideo( index ) {
        if(this.playlistCont && this.playlistItems && this.playlistItems[index]) {
            scrollEvent.scrollTop(this.playlistCont, this.playlistItems[index], 200, 'easeInOutQuad');
        }
    }
    
    /**
     * updates main video when current playing video ends
     * @param {object} data 
     */
    updatePostOnVideoEnd(data) {
        //check if next item is available 
        let isAvailable = this.state.playlist.length > this.state.activeIndex
        let currentVidIndex = 0;
        if(isAvailable) { 
            currentVidIndex = this.state.activeIndex;
        } 
        //update default video and index
        this.setState(() => ({
            defaultVideo: this.state.playlist[currentVidIndex],
            currentIndex: currentVidIndex,
            activeIndex: currentVidIndex + 1,
            isAvailable: isAvailable
        })); 
        this.updateReleaseUrl(this.state.defaultVideo, isAvailable);

        this.scrollToCurrentVideo( this.state.currentIndex ); 
       
    }

    render() {
        const playlist = this.state.playlist;
        if( ! playlist ) return <div></div>;

        if( playlist.length <= 0 ) {
            return (
                ! this.state.hideUnavailableMsg &&
                    <div className={css(playerStyles.unAvailableMsg)}> <span className={css(playerStyles.msgFontStyle)}> {this.state.unAvailableMsg} </span> </div>
            )   
        }
        let defaultVideo = this.state.defaultVideo;
        let playerMetaStyles = [playerStyles.playerMeta];

        //add styles when there is more than 1 video or view link is not empty
        let videoContStyles = playlist.length > 1 || this.state.viewAllLink ? [playerStyles.videoCont] : '';

        //override autoplay
        defaultVideo.videoConfig.autoplay = this.state.autoplay;
        //overriding title without special chars
        defaultVideo.videoConfig.title = defaultVideo.title;
        defaultVideo.videoConfig.enablePlaylist = false;
        
        return ( 
            <div className={css(playerStyles.playerCont)}>
                <div>
                    <div className={css(videoContStyles) + ' vid-player-cont'}>
                        <div className={css(playerStyles.playerSizes)}>
                                <FsPlayer playerRef={'player ref'} playerConfig={defaultVideo.videoConfig}/>
                        </div>
                        <div ref={elem => this.playerMeta = elem} className={css(playerMetaStyles)}>
                            <div ref={el => this.metaCont = el}>
                                <h2 className={css(playerStyles.title)}> {defaultVideo.title} </h2>
                                <span className={css(playerStyles.props)}>
                                    <span className={css(playerStyles.time)}>
                                        {defaultVideo.pubDate}
                                    </span>
                                    <span className={css(playerStyles.category)}>
                                        {defaultVideo.category}
                                    </span>
                                </span>
                                <VideoPlayerShare title={defaultVideo.title} videoUrl={defaultVideo.videoUrl} />
                            </div>
                        </div>
                    </div> 
                </div>
                <div className={css(playerStyles.playlist)}>
                    <VideoPlaylist title={this.state.playlistTitle} videos={playlist} enableShowMore={false} setActiveState={this.setActiveState}
                        onClick={this.updateCurrentPost} showDetails={this.updateDetails} hideTitle={true} upNext={this.state.activeIndex} skipFirst={true}/>
                    { this.state.viewAllLink && <a href={this.state.viewAllLink} className={css(playerStyles.moreLink)}> <span className={css(playerStyles.msgFontStyle)}> View All Videos </span> </a> }
                </div>
            </div>  
        )
    }

}

export default VideoPlayer;